import React, { FC, Fragment } from 'react'
import { InView } from 'react-intersection-observer'
import { TitleAndSubtitleDisplay } from '@/atoms/TitleAndSubtitleDisplay'
import { LandscapeTileCard } from '@/molecules/LandscapeRowCollection'
import { DiscoverItemInteraction, useCardInteractions } from '@/services/Analytics/ContentInteractions'
import { LinkViewModel } from '@/services/RenderService'
import { WatchlistItem } from '@/services/WatchlistService'

export interface WatchlistCardProps {
  watchlistItem: WatchlistItem
  linkModel: LinkViewModel
  itemIndex: number
  title?: string
  hoverStartTimeRef: React.MutableRefObject<Map<string, number>>
  impressionTimeoutRef: React.MutableRefObject<Map<string, NodeJS.Timeout>>
  hasTrackedImpression: React.MutableRefObject<Set<string>>
  createInteraction: (watchlistItem: WatchlistItem, itemIndex: number) => DiscoverItemInteraction | null
}

export const WatchlistCard: FC<WatchlistCardProps> = ({
  watchlistItem,
  linkModel,
  itemIndex,
  title,
  hoverStartTimeRef,
  impressionTimeoutRef,
  hasTrackedImpression,
  createInteraction,
}) => {
  const contentId = watchlistItem?.id ?? ''

  const { handleMouseEnter, handleMouseLeave, handleClick, handleInViewChange } = useCardInteractions({
    contentId,
    item: watchlistItem,
    itemIndex,
    hoverStartTimeRef,
    impressionTimeoutRef,
    hasTrackedImpression,
    createInteraction,
  })

  return (
    <Fragment key={watchlistItem?.id}>
      <InView onChange={handleInViewChange} triggerOnce={false} threshold={0.5}>
        <LandscapeTileCard
          className="mb-2 mr-4"
          linkModel={linkModel}
          key={watchlistItem?.id}
          onClick={handleClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
        <TitleAndSubtitleDisplay className="mr-4" title={title} subtitle={watchlistItem?.name ?? ''} />
      </InView>
    </Fragment>
  )
}
